/* eslint-env browser */
import domify from 'domify';
import page from 'modules/ab-page-js';
import container from 'modules/section-content';
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import splash from './press-page.pug';
import metadata from './metadata.json';
import { App } from './containers';

export default function register() {
  page('/press', initial);
  page('/press/:data', initial);

  page.exit('/press', unMountApp);
  page.exit('/press/:data', unMountApp);
}

function initial(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  const props = Object.assign(window.PRESS_DATA || {}, { route: ctx.params.data || 'press' });
  render(<App {...props} />, document.querySelector('.press-app'));

  return next();
}

function unMountApp(ctx, next) {
  unmountComponentAtNode(document.querySelector('.press-app'));
  return next();
}



// WEBPACK FOOTER //
// ./src/pages/press/press.js